import { getBaseQuery, getBaseUrl } from '../api.util.ts'
import { createApi } from '@reduxjs/toolkit/query/react'
import {
  FirmActionResponse,
  FirmCreateRequest,
  FirmDetailResponse,
  FirmListRequest,
  FirmListResponse,
  FirmUpdateRequest,
  GroupCreateRequest,
  GroupCreateResponse,
  GroupDetailRequest,
  GroupDetailResponse,
  GroupListRequest,
  GroupListResponse,
  GroupModifyResponse,
  GroupUpdateRequest,
} from './firm-management-api.def.ts'

const interfaceName = 'firm'

export const firmManagementApi = createApi({
  reducerPath: 'firmManagementApi',
  baseQuery: getBaseQuery(getBaseUrl(interfaceName)),
  tagTypes: ['managed-firm', 'firm-group'],
  endpoints: (build) => ({
    listFirms: build.query<FirmListResponse, FirmListRequest>({
      query: (params) => ({
        url: '/',
        method: 'GET',
        params: params,
      }),
      providesTags: ['managed-firm'],
    }),
    getGroupList: build.query<GroupListResponse, GroupListRequest>({
      query: (params) => ({
        url: `/${params.firmId}/group/`,
        method: 'GET',
        params: params,
      }),
      providesTags: ['managed-firm', 'firm-group'],
    }),
    createFirm: build.mutation<FirmActionResponse, FirmCreateRequest>({
      query: (payload) => ({
        url: '/',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['managed-firm'],
    }),
    updateFirm: build.mutation<FirmActionResponse, FirmUpdateRequest>({
      query: (payload) => ({
        url: `/${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['managed-firm'],
    }),
    getFirmDetail: build.query<FirmDetailResponse, string>({
      query: (id) => ({
        url: `/${id}`,
        method: 'GET',
      }),
      providesTags: ['managed-firm'],
    }),
    createGroup: build.mutation<GroupCreateResponse, GroupCreateRequest>({
      query: (payload) => ({
        url: `/${payload.firmId}/group/`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['firm-group'],
    }),
    updateGroup: build.mutation<GroupModifyResponse, GroupUpdateRequest>({
      query: (payload) => ({
        url: `/${payload.firmId}/group/${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['firm-group'],
    }),
    getGroupDetail: build.query<GroupDetailResponse, GroupDetailRequest>({
      query: (payload) => ({
        url: `/${payload.firmId}/group/${payload.id}`,
      }),
      providesTags: ['firm-group'],
    }),
  }),
})

export const {
  useListFirmsQuery,
  useLazyGetGroupListQuery,
  useCreateFirmMutation,
  useUpdateFirmMutation,
  useGetFirmDetailQuery,
  useCreateGroupMutation,
  useUpdateGroupMutation,
  useGetGroupDetailQuery,
} = firmManagementApi
